import getAllDas28Jes from "parog-web/components/das28/utils/get-all-das28-jes";
import BioExamResultsReceivedJournalEvent from "parog-web/models/bio-exam-results-received-journal-event";
import type Patient from "parog-web/models/patient";
import { sortBy } from "parog-web/utils/sort";
import mostRecentJe from "./most-recent-je";

export default function getLastBioExamInfos(
  patient: Patient,
  bioExamName: string,
  loinc: string
): Record<string, Date | string | number | undefined> {
  const bioExamsJes = patient.bioExamResultsReceivedJournalEvents.filter(je =>
    je.result(loinc)
  );

  const lastBioExamsJe = bioExamsJes[0];

  const lastDas28JeWithBioExam = getAllDas28Jes(patient)
    ?.filter(je => je[bioExamName])
    .sort(sortBy("occurredAt", "desc"))[0];

  const lastJe = mostRecentJe(lastBioExamsJe, lastDas28JeWithBioExam);

  const toReturn = { occurredAt: lastJe?.occurredAt };
  if (lastJe instanceof BioExamResultsReceivedJournalEvent) {
    toReturn[bioExamName] = lastJe?.result(loinc)?.value;
  } else {
    toReturn[bioExamName] = lastJe?.[bioExamName];
  }
  return toReturn as Record<string, Date | string | number | undefined>;
}
